import { SvgIconProps } from '@mui/material';
import { useFeatureFlag } from 'providers';
import PrimaveraImage from 'assets/images/img-primavera.jpg';
import RusticaPiccanteImage from 'assets/images/img-rustica-piccante.jpg';

const Primavera = ({ height = '120', width = '122', className }: SvgIconProps) => {
  const allowSpinToWin = useFeatureFlag('allowSpinToWin');

  return (
    <>
      {allowSpinToWin ? (
        <svg viewBox="10 0 189 198" width={width} height={height} className={className} fill="none">
          <image width="100%" height="100%" xlinkHref={PrimaveraImage} />
        </svg>
      ) : (
        <svg viewBox="10 0 189 198" width={width} height={height} className={className} fill="none">
          <path
            d="M13.53 132.606C-1.915 107.363-4.904 73.923 8.565 46.353c3.637-7.444 9.216-13.736 14.927-19.723 6.864-7.2 14.144-14.197 22.84-18.993C66.089-3.266 99.498-.525 120.664 3.794c105.363 21.514 83.384 207.183-28.2 180.61-19.561-4.661-37.28-15.001-54.15-25.992-10.145-6.614-18.498-15.532-24.783-25.806Z"
            fill="url(#rusticaPiccante_svg_a)"
          />
          <defs>
            <pattern
              id="rusticaPiccante_svg_a"
              patternContentUnits="objectBoundingBox"
              width={1}
              height={1}
            >
              <use xlinkHref="#rusticaPiccante_svg_b" transform="matrix(.00065 0 0 .00097 0 0)" />
            </pattern>
            <image
              id="rusticaPiccante_svg_b"
              width={2000}
              height={1333}
              xlinkHref={RusticaPiccanteImage}
            />
          </defs>
        </svg>
      )}
    </>
  );
};

export default Primavera;
